import { Layer } from 'react-map-gl';
import { PointFeature } from '../types';
import {
  POINTS_SOURCE_ID,
  SELECTED_POINT_LAYER_ID,
  SELECTED_POINT_OVERLAY_LAYER_ID,
} from './constants';

type Props = {
  selectedPointId: PointFeature['id'];
};
/**
 * The Layer responsible for displaying the selected point
 * on the map
 */
export const SelectedPointLayer = ({ selectedPointId }: Props) => {
  return (
    <>
      <Layer
        id={SELECTED_POINT_OVERLAY_LAYER_ID}
        beforeId={SELECTED_POINT_LAYER_ID}
        type='background'
        paint={{
          'background-color': '#000000',
          'background-opacity': selectedPointId ? 0.4 : 0,
        }}
      />
      <Layer
        id={SELECTED_POINT_LAYER_ID}
        type='circle'
        source={POINTS_SOURCE_ID}
        filter={['==', ['get', 'id'], selectedPointId ?? '']}
        paint={{
          'circle-color': ['get', 'color'], // Color of the circle, fetched from the properties of the source Feature
          'circle-radius': [
            'interpolate',
            ['linear'], // Linear interpolation
            ['zoom'], // Zoom-dependent scaling
            16, // Start zoom level
            9,
            24,
            14,
          ],
          'circle-stroke-width': [
            'interpolate',
            ['linear'],
            ['zoom'], // Zoom-dependent scaling for stroke width
            16, // Start zoom level
            3, // Starting stroke width
            24, // End zoom level
            4.5, // Ending stroke width
          ],
          'circle-stroke-color': '#fff',
        }}
      />
    </>
  );
};
